export default {
  state: {
    mess: {}
  },
  mutations: {
    setMess(state, payload) {
      if (state.mess) state.mess = { ...state.mess, ...payload };
      else state.mess = payload;
    }
  },
  actions: {
    setMess({ commit }, payload) {
      commit("setMess", payload);
    }
  },
  getters: {
    mess(state) {
      return state.mess;
    }
  }
};
